import type { getEnumRule } from "./getEnumRule";

/**
 * Option value for the synthetic "Clear value" entry inside a single-enum
 * `<Select>`. Picked so it can never collide with a real DB value. Shared by
 * `FieldRow`'s edit dropdown and the inspector's value editor, which are the two
 * places a single-select enum can be emptied.
 */
export const CLEAR_SENTINEL = "__clear__";

export function enumSelections(value: string): string[] {
  return value
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

export function isAllowedEnumValue(
  value: string,
  enumRule: ReturnType<typeof getEnumRule>
): boolean {
  if (!enumRule) return true;
  const allowed = new Set(enumRule.options.map((option) => option.value));
  const selections = enumSelections(value);
  if (enumRule.kind === "enum") return selections.length === 1 && allowed.has(value.trim());
  return selections.length > 0 && selections.every((selection) => allowed.has(selection));
}
